define('pubsub/resize',[
    'underscore',
    'cnf',
    '_pubsub'
], function(_,Cnf,Pubsub){
    'use strict';
    
    var oPubsub=new Pubsub(),
        oInstance;
    
    var oResize=function()
    {
        if(oInstance) {
            return oInstance;
        }
        oInstance=this;
        
        this.init=function()
        {
            this.previousState=null;
            this.currentState=null;
            
            this.setSize();
            this.initResize();
        };
        
        this.setSize=function()
        {
            Cnf.width= window.innerWidth;
            Cnf.height=Cnf.$window.height();
            Cnf.isMobile=(Cnf.width<Cnf.mobileBreakpoint);
            Cnf.isTablet=(Cnf.width>=Cnf.mobileBreakpoint) && (Cnf.width<Cnf.desktopBreakpoint);
            Cnf.isDesktop=(Cnf.width>=Cnf.desktopBreakpoint);
            
            //trigger viewport change
            switch(true) {
                case Cnf.width<Cnf.mobileBreakpoint:
                    this.currentState='mobile';
                    break;
                    
                case (Cnf.width>=Cnf.mobileBreakpoint) && (Cnf.width<Cnf.desktopBreakpoint):
                    this.currentState='tablet';
                    break;
                    
                case Cnf.width>=Cnf.desktopBreakpoint:
                    this.currentState='desktop';
                    break;
                    
                default:break;
            }
            
            if(this.previousState!==this.currentState) {
                oPubsub.trigger(Pubsub.VIEWPORT_CHANGE,{
                    previous:this.previousState,
                    current:this.currentState
                });
                
                this.previousState=this.currentState;
                Cnf.viewport=this.currentState;
            }
            
        };
        
        this.initResize=function()
        {
            Cnf.$window.bind('resize',_.debounce(
                _.bind(function() {
                    _.bind(this.setSize,this)();
                    
                    oPubsub.trigger(Pubsub.RESIZE,{
                        width:Cnf.width,
                        height:Cnf.height,
                        currentState:this.currentState,
                        isMobile:Cnf.isMobile,
                        isTablet:Cnf.isTablet,
                        isDesktop:Cnf.isDesktop
                    });
                },this),
                50
            ));
        };
        
        this.init();
    };
    
    return oResize;
});
